<template>
  <v-dialog :value="value" @input="val => $emit('input', val)" max-width="290">
    <v-card>
      <v-card-title class="headline" v-html="title"></v-card-title>

      <v-card-text>
        <slot name="text"></slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: ['value', 'title']
}
</script>
